import { CheckCircle } from "@/components";
import useStep3 from "./useStep4"
import { Button } from "@/components/ui";
import { StepsProps } from "../types";

const Step4 = ({onBackClick}: StepsProps) => {
  const {bulkUploadDtl, communityData} = useStep3();

  return (
    <div className="bg-white flex flex-col items-center justify-center p-6 rounded-md shadow-md my-4 gap-4">
      <div>
        <CheckCircle />
      </div>
      <h2 className="text-[24px] font-medium">Import Completed</h2>
      <div className="text-[14px] text-neutral-500 md:w-[350px] text-center my-4">
        {bulkUploadDtl?.imported || "0"} properties were added to {communityData?.name}.
        The {bulkUploadDtl?.skipped} skipped rows were saved to an error report so you can fix and re-upload them.
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 border-1 rounded-md border-gray-200">
        <div className="flex flex-col items-center justify-center p-4">
          <span className="text-[24px] text-green-600">{bulkUploadDtl?.imported}</span>
          <span className="text-gray-400 text-[14px]">Imported</span>
        </div>
        <div className="flex flex-col items-center justify-center border-l-1 border-r-1 p-4">
          <span className="text-[24px] text-yellow-600">{bulkUploadDtl?.withDefaults}</span>
          <span className="text-gray-400 text-[14px]">With Defaults</span>
        </div>
        <div className="flex flex-col items-center justify-center p-4">
          <span className="text-[24px] text-black">{bulkUploadDtl?.skipped}</span>
          <span className="text-gray-400 text-[14px]">Skipped</span>
        </div>
      </div>

      <div className="flex flex-row items-center gap-4 my-4">
        <Button variant="outline">Download Error Report</Button>
        <Button onClick={onBackClick}>View Users</Button>
      </div>
    </div>
  )
}

export default Step4;